/**
 * Queen B Academy - Resources & Quizzes
 * Downloadable materials and practice quizzes for each course
 */

// Downloadable Resources by Course
export const COURSE_RESOURCES = {
  "cdl-mastery-101": [
    {
      id: "cdl-r1",
      title: "Pre-Trip Inspection Checklist",
      description: "Complete 7-point inspection checklist with all components to check",
      type: "pdf",
      filename: "pretip_inspection_checklist.pdf",
      icon: "FileCheck"
    },
    {
      id: "cdl-r2",
      title: "Air Brake Study Sheet",
      description: "Quick reference for air brake components and tests",
      type: "pdf",
      filename: "air_brake_study_sheet.pdf",
      icon: "FileText"
    },
    {
      id: "cdl-r3",
      title: "CDL Classes & Endorsements Chart",
      description: "Visual guide to all CDL classes and endorsement requirements",
      type: "pdf",
      filename: "cdl_classes_chart.pdf",
      icon: "Table"
    },
    {
      id: "cdl-r4",
      title: "Backing Maneuvers Guide",
      description: "Step-by-step diagrams for straight, offset, and parallel backing",
      type: "pdf",
      filename: "backing_maneuvers_guide.pdf",
      icon: "Move"
    },
    {
      id: "cdl-r5",
      title: "Road Test Score Sheet",
      description: "Know exactly what examiners grade during your road test",
      type: "pdf",
      filename: "road_test_score_sheet.pdf",
      icon: "ClipboardCheck"
    }
  ],
  "dispatcher-101": [
    {
      id: "disp-r1",
      title: "Rate Negotiation Call Scripts",
      description: "Word-for-word scripts for negotiating with brokers",
      type: "pdf",
      filename: "rate_negotiation_scripts.pdf",
      icon: "Phone"
    },
    {
      id: "disp-r2",
      title: "Broker Email Templates",
      description: "Professional email templates for every situation",
      type: "pdf",
      filename: "broker_email_templates.pdf",
      icon: "Mail"
    },
    {
      id: "disp-r3",
      title: "Daily Dispatch Checklist",
      description: "Morning to evening task checklist for dispatchers",
      type: "pdf",
      filename: "daily_dispatch_checklist.pdf",
      icon: "CheckSquare"
    },
    {
      id: "disp-r4",
      title: "Carrier Packet Template",
      description: "Complete carrier packet with all required documents",
      type: "pdf",
      filename: "carrier_packet_template.pdf",
      icon: "FolderOpen"
    },
    {
      id: "disp-r5",
      title: "Load Board Comparison Chart",
      description: "Feature and pricing comparison of major load boards",
      type: "pdf",
      filename: "load_board_comparison.pdf",
      icon: "BarChart"
    }
  ],
  "trucking-101": [
    {
      id: "truck-r1",
      title: "Cost Per Mile Calculator",
      description: "Excel spreadsheet to calculate your true operating costs",
      type: "xlsx",
      filename: "cost_per_mile_calculator.xlsx",
      icon: "Calculator"
    },
    {
      id: "truck-r2",
      title: "First 90 Days Checklist",
      description: "Week-by-week milestones for new authority holders",
      type: "pdf",
      filename: "first_90_days_checklist.pdf",
      icon: "Calendar"
    },
    {
      id: "truck-r3",
      title: "Maintenance Log Template",
      description: "Track all maintenance with this organized log",
      type: "pdf",
      filename: "maintenance_log_template.pdf",
      icon: "Wrench"
    },
    {
      id: "truck-r4",
      title: "Authority Setup Guide",
      description: "Step-by-step guide with all required registrations",
      type: "pdf",
      filename: "authority_setup_guide.pdf",
      icon: "FileText"
    },
    {
      id: "truck-r5",
      title: "Insurance Comparison Worksheet",
      description: "Compare quotes and coverage from multiple insurers",
      type: "pdf",
      filename: "insurance_comparison_worksheet.pdf",
      icon: "Shield"
    }
  ],
  "freight-broker-101": [
    {
      id: "broker-r1",
      title: "Shipper Cold Call Scripts",
      description: "Proven scripts for prospecting new shippers",
      type: "pdf",
      filename: "shipper_cold_call_scripts.pdf",
      icon: "Phone"
    },
    {
      id: "broker-r2",
      title: "Carrier Vetting Checklist",
      description: "Complete verification checklist for new carriers",
      type: "pdf",
      filename: "carrier_vetting_checklist.pdf",
      icon: "UserCheck"
    },
    {
      id: "broker-r3",
      title: "Load Lifecycle Workflow",
      description: "Visual workflow from quote to payment",
      type: "pdf",
      filename: "load_lifecycle_workflow.pdf",
      icon: "GitBranch"
    },
    {
      id: "broker-r4",
      title: "Broker-Carrier Agreement Template",
      description: "Professional contract template for carrier relationships",
      type: "pdf",
      filename: "broker_carrier_agreement.pdf",
      icon: "FileSignature"
    },
    {
      id: "broker-r5",
      title: "Margin Calculator",
      description: "Spreadsheet to calculate and track your margins",
      type: "xlsx",
      filename: "broker_margin_calculator.xlsx",
      icon: "PieChart"
    }
  ]
};

// Quiz Questions by Module
export const MODULE_QUIZZES = {
  // CDL Mastery 101 Quizzes
  "cdl-m1": {
    title: "CDL Foundations Quiz",
    passingScore: 80,
    questions: [
      {
        id: "cdl-m1-q1",
        question: "What is the minimum GCWR for a Class A CDL?",
        options: [
          "10,001 lbs",
          "26,001 lbs",
          "33,001 lbs",
          "80,000 lbs"
        ],
        correctAnswer: 1,
        explanation: "Class A CDL requires a GCWR of 26,001 lbs or more, with the towed vehicle weighing more than 10,000 lbs."
      },
      {
        id: "cdl-m1-q2",
        question: "Which endorsement is required to transport hazardous materials?",
        options: [
          "N - Tank",
          "P - Passenger",
          "H - Hazmat",
          "T - Doubles/Triples"
        ],
        correctAnswer: 2,
        explanation: "The H endorsement (Hazardous Materials) is required and includes a TSA background check."
      },
      {
        id: "cdl-m1-q3",
        question: "What is the minimum age for interstate CDL driving?",
        options: [
          "18 years old",
          "19 years old",
          "21 years old",
          "25 years old"
        ],
        correctAnswer: 2,
        explanation: "Federal law requires drivers to be 21 for interstate commerce. 18-20 year olds can only drive intrastate in many states."
      },
      {
        id: "cdl-m1-q4",
        question: "What does the 'X' endorsement combine?",
        options: [
          "Hazmat and Passenger",
          "Tank and Doubles",
          "Hazmat and Tank",
          "School Bus and Passenger"
        ],
        correctAnswer: 2,
        explanation: "The X endorsement combines H (Hazmat) and N (Tank) endorsements."
      },
      {
        id: "cdl-m1-q5",
        question: "How long must you hold a CLP before taking the CDL skills test?",
        options: [
          "7 days",
          "14 days",
          "30 days",
          "60 days"
        ],
        correctAnswer: 1,
        explanation: "Federal regulations require holding a Commercial Learner's Permit (CLP) for at least 14 days."
      }
    ]
  },
  "cdl-m2": {
    title: "General Knowledge Quiz",
    passingScore: 80,
    questions: [
      {
        id: "cdl-m2-q1",
        question: "What is the recommended following distance rule for commercial vehicles?",
        options: [
          "2 seconds",
          "1 second per 10 feet of vehicle length",
          "3 car lengths",
          "50 feet"
        ],
        correctAnswer: 1,
        explanation: "The rule is 1 second for every 10 feet of vehicle length, plus 1 additional second at speeds over 40 mph."
      },
      {
        id: "cdl-m2-q2",
        question: "How often should you check your mirrors while driving?",
        options: [
          "Every minute",
          "Every 5-8 seconds",
          "Only when changing lanes",
          "Every 30 seconds"
        ],
        correctAnswer: 1,
        explanation: "Mirrors should be checked every 5-8 seconds to maintain awareness of surrounding traffic."
      },
      {
        id: "cdl-m2-q3",
        question: "What does 'controlled braking' mean?",
        options: [
          "Pumping the brakes rapidly",
          "Applying brakes hard enough to slow without locking wheels",
          "Using only the parking brake",
          "Braking only on straightaways"
        ],
        correctAnswer: 1,
        explanation: "Controlled braking means applying brakes firmly but not hard enough to lock wheels, allowing continued steering."
      },
      {
        id: "cdl-m2-q4",
        question: "When should you reduce speed below the posted limit?",
        options: [
          "Never - posted limits are always safe",
          "Only in construction zones",
          "During adverse conditions like weather, traffic, or road issues",
          "Only at night"
        ],
        correctAnswer: 2,
        explanation: "Posted limits are for ideal conditions. Speed should be reduced for weather, traffic, visibility, and road conditions."
      },
      {
        id: "cdl-m2-q5",
        question: "How far ahead should you scan while driving?",
        options: [
          "5-8 seconds",
          "12-15 seconds",
          "1 mile",
          "To the next intersection"
        ],
        correctAnswer: 1,
        explanation: "You should scan 12-15 seconds ahead to identify hazards early and have time to react."
      }
    ]
  },
  "cdl-m3": {
    title: "Air Brakes Quiz",
    passingScore: 80,
    questions: [
      {
        id: "cdl-m3-q1",
        question: "At what PSI should the low air pressure warning activate?",
        options: [
          "40 PSI",
          "60 PSI",
          "80 PSI",
          "100 PSI"
        ],
        correctAnswer: 1,
        explanation: "The low air warning must activate before pressure drops below 60 PSI."
      },
      {
        id: "cdl-m3-q2",
        question: "What is the maximum air leakage rate for a single vehicle in one minute?",
        options: [
          "1 PSI",
          "2 PSI",
          "3 PSI",
          "4 PSI"
        ],
        correctAnswer: 2,
        explanation: "Single vehicles should not leak more than 3 PSI in one minute; combination vehicles allow 4 PSI."
      },
      {
        id: "cdl-m3-q3",
        question: "What happens when spring brakes activate?",
        options: [
          "Nothing - they are only for parking",
          "Brakes apply mechanically when air is released",
          "Air pressure increases",
          "The horn sounds"
        ],
        correctAnswer: 1,
        explanation: "Spring brakes are held back by air pressure. When air is released (intentionally or by leak), powerful springs apply the brakes."
      },
      {
        id: "cdl-m3-q4",
        question: "What is 'brake fade'?",
        options: [
          "Normal brake operation",
          "Loss of braking power due to overheating",
          "A type of brake adjustment",
          "Brake lights dimming"
        ],
        correctAnswer: 1,
        explanation: "Brake fade occurs when brakes overheat from extended use, causing loss of stopping power."
      },
      {
        id: "cdl-m3-q5",
        question: "What is the typical 'brake lag' time for air brakes?",
        options: [
          "Instant",
          "About 1/2 second",
          "2-3 seconds",
          "5 seconds"
        ],
        correctAnswer: 1,
        explanation: "Air brakes have approximately 1/2 second delay between pedal application and brake engagement."
      }
    ]
  },
  "cdl-m4": {
    title: "Combination Vehicles Quiz",
    passingScore: 80,
    questions: [
      {
        id: "cdl-m4-q1",
        question: "What is 'off-tracking'?",
        options: [
          "When the truck leaves the road",
          "When trailer wheels follow a shorter path than tractor wheels in turns",
          "A GPS malfunction",
          "When brakes don't work properly"
        ],
        correctAnswer: 1,
        explanation: "Off-tracking means trailer wheels track inside (shorter path than) the tractor wheels, requiring wider turns."
      },
      {
        id: "cdl-m4-q2",
        question: "Which air line should be connected FIRST when coupling?",
        options: [
          "Service (blue)",
          "Emergency (red)",
          "Either one",
          "Electrical first"
        ],
        correctAnswer: 1,
        explanation: "Connect the emergency (red) line first, then the service (blue) line."
      },
      {
        id: "cdl-m4-q3",
        question: "What should you do after coupling to test the connection?",
        options: [
          "Immediately drive away",
          "Pull forward gently to test the fifth wheel lock",
          "Sound the horn",
          "Check the mirrors"
        ],
        correctAnswer: 1,
        explanation: "After coupling, pull forward gently against the locked trailer brakes to verify the fifth wheel is locked."
      },
      {
        id: "cdl-m4-q4",
        question: "What is 'rearward amplification' (crack-the-whip)?",
        options: [
          "Sound from the exhaust",
          "Sudden steering movements amplified toward the rear of combination",
          "A type of horn signal",
          "Trailer brakes engaging"
        ],
        correctAnswer: 1,
        explanation: "Rearward amplification means sudden movements are amplified toward the rear, especially with multiple trailers."
      },
      {
        id: "cdl-m4-q5",
        question: "Before uncoupling, what must you do with the landing gear?",
        options: [
          "Remove it completely",
          "Lower it until it makes firm contact with the ground",
          "Leave it fully raised",
          "Grease it"
        ],
        correctAnswer: 1,
        explanation: "Lower landing gear until it firmly contacts the ground before releasing the fifth wheel."
      }
    ]
  },
  "cdl-m5": {
    title: "Pre-Trip Inspection Quiz",
    passingScore: 80,
    questions: [
      {
        id: "cdl-m5-q1",
        question: "What is the minimum tread depth for steer tires?",
        options: [
          "2/32 inch",
          "4/32 inch",
          "6/32 inch",
          "8/32 inch"
        ],
        correctAnswer: 1,
        explanation: "Steer tires require a minimum of 4/32 inch tread depth; other tires require 2/32 inch."
      },
      {
        id: "cdl-m5-q2",
        question: "How many warning triangles are required safety equipment?",
        options: [
          "1",
          "2",
          "3",
          "4"
        ],
        correctAnswer: 2,
        explanation: "Three warning triangles are required emergency equipment."
      },
      {
        id: "cdl-m5-q3",
        question: "What should you check on the steering wheel during cab inspection?",
        options: [
          "Color",
          "Play/free movement (max 2 inches on 20-inch wheel)",
          "Temperature",
          "Size"
        ],
        correctAnswer: 1,
        explanation: "Check steering wheel play - it should have no more than 2 inches of free movement on a 20-inch wheel."
      },
      {
        id: "cdl-m5-q4",
        question: "When checking engine oil, what indicates coolant contamination?",
        options: [
          "Black color",
          "Milky or frothy appearance",
          "Low level",
          "Hot temperature"
        ],
        correctAnswer: 1,
        explanation: "Milky or frothy oil indicates coolant is mixing with oil, a serious problem."
      },
      {
        id: "cdl-m5-q5",
        question: "How long should a thorough pre-trip inspection take?",
        options: [
          "5 minutes",
          "10-15 minutes",
          "30-45 minutes",
          "2 hours"
        ],
        correctAnswer: 2,
        explanation: "A thorough pre-trip inspection takes approximately 30-45 minutes."
      }
    ]
  },

  // Dispatcher 101 Quizzes
  "disp-m1": {
    title: "Dispatcher Role Quiz",
    passingScore: 80,
    questions: [
      {
        id: "disp-m1-q1",
        question: "What percentage do independent dispatchers typically charge?",
        options: [
          "1-2%",
          "3-10%",
          "15-20%",
          "25-30%"
        ],
        correctAnswer: 1,
        explanation: "Independent dispatchers typically charge 3-10% of the load revenue."
      },
      {
        id: "disp-m1-q2",
        question: "What is the primary role of a freight dispatcher?",
        options: [
          "Drive trucks",
          "Connect carriers with profitable loads",
          "Repair equipment",
          "Inspect cargo"
        ],
        correctAnswer: 1,
        explanation: "Dispatchers serve as the link between carriers and freight, finding and booking profitable loads."
      },
      {
        id: "disp-m1-q3",
        question: "When should you respond to broker calls during business hours?",
        options: [
          "Within 24 hours",
          "Within 15 minutes",
          "Next business day",
          "When convenient"
        ],
        correctAnswer: 1,
        explanation: "Broker calls should be returned within 15 minutes during business hours to maintain relationships."
      }
    ]
  },
  "disp-m2": {
    title: "Finding Loads Quiz",
    passingScore: 80,
    questions: [
      {
        id: "disp-m2-q1",
        question: "Which is the largest load board network?",
        options: [
          "123Loadboard",
          "Uber Freight",
          "DAT",
          "Amazon Freight"
        ],
        correctAnswer: 2,
        explanation: "DAT (Dial-A-Truck) is the industry's largest load board network."
      },
      {
        id: "disp-m2-q2",
        question: "What is a red flag when evaluating a load posting?",
        options: [
          "Posted rate near market value",
          "No rate posted and 'ASAP' pickup",
          "Standard pickup window",
          "Established broker"
        ],
        correctAnswer: 1,
        explanation: "No rate posted often means lowball rates, and 'ASAP' can indicate a problem load or desperate (negotiable) situation."
      }
    ]
  },
  "disp-m3": {
    title: "Rate Negotiation Quiz",
    passingScore: 80,
    questions: [
      {
        id: "disp-m3-q1",
        question: "What does 'anchoring' mean in negotiation?",
        options: [
          "Refusing to negotiate",
          "Starting higher than you expect to settle",
          "Accepting the first offer",
          "Walking away immediately"
        ],
        correctAnswer: 1,
        explanation: "Anchoring means starting with a higher rate than you expect, giving room to negotiate."
      },
      {
        id: "disp-m3-q2",
        question: "When calculating minimum rate, what should be included?",
        options: [
          "Just fuel",
          "Driver pay + fuel + fixed costs + profit",
          "Only the driver pay",
          "Whatever the broker offers"
        ],
        correctAnswer: 1,
        explanation: "Minimum rate should cover driver pay, fuel, fixed costs, AND profit margin."
      }
    ]
  },

  // Trucking 101 Quizzes
  "truck-m1": {
    title: "Starting a Trucking Company Quiz",
    passingScore: 80,
    questions: [
      {
        id: "truck-m1-q1",
        question: "Which business structure is recommended for most owner-operators?",
        options: [
          "Sole Proprietorship",
          "LLC (Limited Liability Company)",
          "General Partnership",
          "None - just use your name"
        ],
        correctAnswer: 1,
        explanation: "LLC provides liability protection, tax flexibility, and professional appearance."
      },
      {
        id: "truck-m1-q2",
        question: "What is the approximate startup cost range for an owner-operator?",
        options: [
          "$5,000-10,000",
          "$10,000-25,000",
          "$40,000-100,000",
          "Over $500,000"
        ],
        correctAnswer: 2,
        explanation: "Total startup costs typically range from $40,000-100,000+ including down payment, insurance, authority, and operating capital."
      }
    ]
  },
  "truck-m2": {
    title: "FMCSA & DOT Quiz",
    passingScore: 80,
    questions: [
      {
        id: "truck-m2-q1",
        question: "What is the 11-hour driving limit under HOS rules?",
        options: [
          "11 hours total per week",
          "11 hours after 10 consecutive hours off duty",
          "11 hours per day regardless of rest",
          "11 hours per load"
        ],
        correctAnswer: 1,
        explanation: "Drivers may drive maximum 11 hours after 10 consecutive hours off duty."
      },
      {
        id: "truck-m2-q2",
        question: "What is the filing fee for MC Authority?",
        options: [
          "$100",
          "$300",
          "$500",
          "$1,000"
        ],
        correctAnswer: 1,
        explanation: "The FMCSA filing fee for Motor Carrier Authority is $300."
      }
    ]
  },
  "truck-m3": {
    title: "Insurance Structure Quiz",
    passingScore: 80,
    questions: [
      {
        id: "truck-m3-q1",
        question: "What is the minimum primary liability insurance for general freight?",
        options: [
          "$100,000",
          "$500,000",
          "$750,000",
          "$1,000,000"
        ],
        correctAnswer: 2,
        explanation: "General freight requires minimum $750,000 primary liability coverage."
      },
      {
        id: "truck-m3-q2",
        question: "What does 'bobtail insurance' cover?",
        options: [
          "Cargo damage",
          "The truck when not under dispatch",
          "Multiple trailers",
          "Employee injuries"
        ],
        correctAnswer: 1,
        explanation: "Bobtail/non-trucking liability covers the truck during personal use or when not dispatched."
      }
    ]
  },

  // Freight Broker 101 Quizzes
  "broker-m1": {
    title: "Broker Role Quiz",
    passingScore: 80,
    questions: [
      {
        id: "broker-m1-q1",
        question: "What is a typical broker margin percentage?",
        options: [
          "1-5%",
          "10-20%",
          "30-40%",
          "50%+"
        ],
        correctAnswer: 1,
        explanation: "Typical broker margins range from 10-20% of the shipper's payment."
      },
      {
        id: "broker-m1-q2",
        question: "What distinguishes a broker from a carrier?",
        options: [
          "Brokers own trucks, carriers don't",
          "Brokers arrange transportation but don't own/operate trucks",
          "There is no difference",
          "Brokers only work with hazmat"
        ],
        correctAnswer: 1,
        explanation: "Brokers arrange transportation but don't own or operate trucks - they connect shippers with carriers."
      }
    ]
  },
  "broker-m2": {
    title: "Broker Authority Quiz",
    passingScore: 80,
    questions: [
      {
        id: "broker-m2-q1",
        question: "What is the minimum surety bond requirement for brokers?",
        options: [
          "$10,000",
          "$25,000",
          "$75,000",
          "$100,000"
        ],
        correctAnswer: 2,
        explanation: "Brokers must maintain a $75,000 surety bond or trust fund."
      },
      {
        id: "broker-m2-q2",
        question: "What does a surety bond protect?",
        options: [
          "The broker from lawsuits",
          "Carriers and shippers from broker non-payment",
          "The broker's office",
          "Nothing - it's just required"
        ],
        correctAnswer: 1,
        explanation: "The bond protects carriers and shippers, providing financial guarantee if the broker doesn't pay."
      }
    ]
  }
};

// Get resources for a course
export const getResourcesForCourse = (courseId) => {
  return COURSE_RESOURCES[courseId] || [];
};

// Get quiz for a module
export const getQuizForModule = (moduleId) => {
  return MODULE_QUIZZES[moduleId] || null;
};

// Calculate quiz score
export const calculateQuizScore = (moduleId, answers) => {
  const quiz = MODULE_QUIZZES[moduleId];
  if (!quiz) return null;

  let correct = 0;
  quiz.questions.forEach((q, idx) => {
    if (answers[idx] === q.correctAnswer) {
      correct++;
    }
  });

  const score = Math.round((correct / quiz.questions.length) * 100);
  return {
    score,
    correct,
    total: quiz.questions.length,
    passed: score >= quiz.passingScore,
    passingScore: quiz.passingScore
  };
};

export default {
  COURSE_RESOURCES,
  MODULE_QUIZZES,
  getResourcesForCourse,
  getQuizForModule,
  calculateQuizScore
};
